<div class="page-container">
  <div class="page-header-container form-page-header-container">
    <sxw-bread-crumb [items]="breadCrumb()" class="mb-20" />
    <app-page-header [title]="'STOCK_TYPE.TITLES.VIEW'" [cancelLink]="StockTypeRoutePaths.ROOT" cancelLabel="COMMON.CANCEL_LABEL" />
  </div>

  <div class="page-content-container form-page-content-container">
    <sxw-form [formModel]="formModel">
      <app-stock-type-form />
    </sxw-form>
  </div>
</div>
